import { space } from '@op/opds.tokens';
import { ReactElement } from 'react';
import { IconEtf } from '@op/opds.opux-icons/finance';
import { Message } from '@messageformat/react';
import { Col, Row } from '@op/opds.opux';
import TextComponent from '../TextComponent';
import { ReactComponent as MoneyImage } from '../../images/OP_symbolikuvitus_96_132.svg';
import { ReactComponent as TimeImage } from '../../images/OP_symbolikuvitus_96_136.svg';
import { ReactComponent as CoinsImage } from '../../images/OP_symbolikuvitus_96_142.svg';
import { ReactComponent as CloudImage } from '../../images/OP_symbolikuvitus_96_072.svg';
import { ReactComponent as CashImage } from '../../images/OP_symbolikuvitus_96_034.svg';
import { ReactComponent as HandsImage } from '../../images/OP_symbolikuvitus_96_129.svg';

const InsuranceSaving = (): ReactElement => {
  return (
    <>
      <div style={{ paddingTop: space.xxs, paddingBottom: space.default }}>
        <div className="investoracademy-medium-ball">
          <IconEtf className="investoracademy-small-svg" />
        </div>
      </div>
      <h4
        className="opds-styles-v1-text-title-xxl"
        style={{ textAlign: 'center', paddingBottom: space.default }}
      >
        <Message id="course6.expanderSubtitle1" />
      </h4>
      <TextComponent messageId="course6.expanderContent1" twoColumns />
      <div style={{ paddingTop: space.xxs }}>
        <MoneyImage aria-hidden="true" className="investoracademy-tiny-svg" />
      </div>
      <h5
        className="opds-styles-v1-text-title-large"
        style={{ textAlign: 'center', paddingBottom: space.default }}
      >
        <Message id="course6.expanderSubtitle2" />
      </h5>
      <TextComponent messageId="course6.expanderContent2" twoColumns />
      <Row>
        <Col xs={12} md={6}>
          <div style={{ paddingTop: space.xxs }}>
            <TimeImage aria-hidden="true" className="investoracademy-tiny-svg" />
          </div>
          <h5
            className="opds-styles-v1-text-title-large"
            style={{ textAlign: 'center', paddingBottom: space.default }}
          >
            <Message id="course6.expanderSubtitle3" />
          </h5>
          <TextComponent messageId="course6.expanderContent3" twoColumns={false} />
        </Col>
        <Col xs={12} md={6}>
          <div style={{ paddingTop: space.xxs }}>
            <CoinsImage aria-hidden="true" className="investoracademy-tiny-svg" />
          </div>
          <h5
            className="opds-styles-v1-text-title-large"
            style={{ textAlign: 'center', paddingBottom: space.default }}
          >
            <Message id="course6.expanderSubtitle4" />
          </h5>
          <TextComponent messageId="course6.expanderContent4" twoColumns={false} />
        </Col>
      </Row>
      <div style={{ paddingTop: space.xxs }}>
        <CloudImage aria-hidden="true" className="investoracademy-tiny-svg" />
      </div>
      <h5
        className="opds-styles-v1-text-title-large"
        style={{ textAlign: 'center', paddingBottom: space.default }}
      >
        <Message id="course6.expanderSubtitle5" />
      </h5>
      <TextComponent messageId="course6.expanderContent5" twoColumns />
      <div style={{ paddingTop: space.xxs }}>
        <CashImage aria-hidden="true" className="investoracademy-tiny-svg" />
      </div>
      <h5
        className="opds-styles-v1-text-title-large"
        style={{ textAlign: 'center', paddingBottom: space.default }}
      >
        <Message id="course6.expanderSubtitle6" />
      </h5>
      <TextComponent messageId="course6.expanderContent6" twoColumns />
      <div style={{ paddingTop: space.xxs }}>
        <HandsImage aria-hidden="true" className="investoracademy-tiny-svg" />
      </div>
      <h5
        className="opds-styles-v1-text-title-large"
        style={{ textAlign: 'center', paddingBottom: space.default }}
      >
        <Message id="course6.expanderSubtitle7" />
      </h5>
      <TextComponent messageId="course6.expanderContent7" twoColumns={false} />
    </>
  );
};
export default InsuranceSaving;
